import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';
import SoftInput from 'components/SoftInput'; // Asegúrate de que la ruta es correcta

function CustomInputDate({ initialValue, textAlign, ...rest }) {
    const [value, setValue] = useState(initialValue);

    const handleChange = date => {
        setValue(date);
    };

    return (
        <Flatpickr
            {...rest}
            value={value}
            onChange={handleChange}
            render={({ defaultValue }, ref) => (
                <SoftInput
                    defaultValue={defaultValue}
                    inputRef={ref}
                    style={{
                        border: 'none',
                        background: 'none',
                        outline: 'none',
                        width: '100%',
                        textAlign,
                        ...rest.style, // Permite que se pasen estilos adicionales si es necesario
                    }}
                />
            )}
        />
    );
}

CustomInputDate.propTypes = {
    initialValue: PropTypes.string.isRequired,
    textAlign: PropTypes.oneOf(['left', 'right']),
    style: PropTypes.object, // Permitir que se pasen estilos adicionales como prop
};

CustomInputDate.defaultProps = {
    textAlign: 'right', // Alineación predeterminada a la izquierda
};

export default CustomInputDate;
